export default "__VITE_ASSET__BaFjNZfS__"